import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import Card from '../../../ui/Card/Card';
import styles from './TrendingAudiosPage.module.css';
import TrendingAudios from '../../../Modules/TikTok/trendingAudios/features/TrendingAudios/TrendingAudios';

const TrendingAudiosPage = () => (
    <>
        <NavBar />
        <Card className={styles.content}>
            <TrendingAudios />
        </Card>
    </>
);

export default TrendingAudiosPage;
